export class EMaintenanceWriteBlockedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'EMaintenanceWriteBlockedError'
  }
}

